module.exports = __webpack_public_path__ + "f1aa1d807917e4e3ccdeaa8af8ec33a6.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/main/stat-diverse.png
// module id = 176
// module chunks = 0